var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45454 0.81818H25.8182C26.7219 0.81818 27.4545 1.55081 27.4545 2.45454V13.1818C27.4545 14.0855 26.7219 14.8182 25.8182 14.8182H9.18182L4.81818 18.1818V14.8182H2.45454C1.55081 14.8182 0.81818 14.0855 0.81818 13.1818V2.45454C0.81818 1.55081 1.55081 0.81818 2.45454 0.81818Z",
    stroke: "#F8F9FA",
    strokeWidth: 1.63636,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5H22.2727M6 7.81818H22.2727M6 11.1364H17.9091",
    stroke: "#F8F9FA",
    strokeWidth: 1.15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationList);
export default __webpack_public_path__ + "static/media/conversation-list.2336d6f718c6db8322bc2a59c5142d1e.svg";
export { ForwardRef as ReactComponent };